export function DummyModule(props) {
  return (
    <div className="dummy-module">
      <div className="css-1mrbqej">
        <div className="css-kdxwf1">
          <div className="css-1bq9n3y">
            <p className="css-uklgv6">Dow Jones Top News</p>
            <div className="css-pqzzby">
              <div className="css-1xzc2un">
                <p role="status" aria-live="polite" className="css-1gj9qdo">
                  Latest update 04:55
                </p>
              </div>
              <div className="css-1xzc2un">
                <div
                  role="status"
                  aria-live="polite"
                  aria-label="Latest news available"
                  className="css-1ho1ezh"
                >
                  <button
                    type="button"
                    data-testid="button"
                    aria-label="Refresh button"
                    className="css-1s2wf39"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                      focusable="false"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      overrides="[object Object]"
                      className="css-1yil0t2 ex0cdmw0"
                    >
                      <path fill="none" d="M0 0h24v24H0z"></path>
                      <path d="M17.65 6.35A7.958 7.958 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="css-1bq9n3y">
            <button
              type="button"
              data-testid="button"
              className="css-bgiubj"
              aria-haspopup="true"
              aria-expanded="false"
              aria-pressed="false"
              aria-live="polite"
              id="ref-:ra:"
            >
              <span className="css-1cw7o2r">Market Driving Events (Japan)</span>
              <svg
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                className="css-169sv57 ex0cdmw0"
              >
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M7 10l5 5 5-5z"></path>
              </svg>
            </button>
          </div>
        </div>
        <div className="css-mb1uql">
          <div className="css-5zdua">
            <div className="css-3y5ajr">
              <div className="leftBox css-5gl0vl" width="100%">
                <div
                  className="topMetadata css-fikby2"
                  data-testid="MainMetadata"
                >
                  <div className="css-1dq90q3">
                    <p className="css-1fj6odc">
                      WSJ Japanese, 29 Jul 2024, 14:35 AWST
                    </p>
                  </div>
                </div>
                <div data-testid="HeadlineContentDiv" className="css-1g0ixsb">
                  <div className="headlinesDiv css-5gl0vl" width="100%">
                    <div className="css-a087gx">
                      <h2 className="headline css-dbb3w6" tabIndex="0">
                        <span role="link" tabIndex="0">
                          あいうえお
                        </span>
                      </h2>
                    </div>
                    <p className="abstractText css-1anudkt">
                      　ああああチャートホームテスト
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="css-1pubcq1">
              <hr
                data-testid="divider"
                aria-hidden="true"
                className="css-v5tibb"
              />
            </div>
          </div>
          <div className="css-5zdua">
            <div className="css-3y5ajr">
              <div className="leftBox css-5gl0vl" width="100%">
                <div
                  className="topMetadata css-fikby2"
                  data-testid="MainMetadata"
                >
                  <div className="css-1dq90q3">
                    <p className="css-1fj6odc">
                      WSJ Japanese, 10 Apr 2023, 10:23 AWST
                    </p>
                  </div>
                </div>
                <div data-testid="HeadlineContentDiv" className="css-1g0ixsb">
                  <div className="headlinesDiv css-5gl0vl" width="100%">
                    <div className="css-a087gx">
                      <h2 className="headline css-dbb3w6" tabIndex="0">
                        <span role="link" tabIndex="0">
                          ロシアの悪名高い刑務所、WSJ記者はここにいる
                        </span>
                      </h2>
                    </div>
                    <p className="abstractText css-1anudkt">
                      　レフォルトボ刑務所では他の収容者の姿を見ることもなく雑音も聞こえないため、「頭がおかしくなる」と元収容者は語る。
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="css-1pubcq1">
              <hr
                data-testid="divider"
                aria-hidden="true"
                className="css-v5tibb"
              />
            </div>
          </div>
          <div className="css-5zdua">
            <div className="css-3y5ajr">
              <div className="leftBox css-5gl0vl" width="100%">
                <div
                  className="topMetadata css-fikby2"
                  data-testid="MainMetadata"
                >
                  <div className="css-1dq90q3">
                    <p className="css-1fj6odc">
                      WSJ Japanese, 01 Dec 2023, 18:04 AWST
                    </p>
                  </div>
                </div>
                <div data-testid="HeadlineContentDiv" className="css-1g0ixsb">
                  <div className="headlinesDiv css-5gl0vl" width="100%">
                    <div className="css-a087gx">
                      <h2 className="headline css-dbb3w6" tabIndex="0">
                        <span role="link" tabIndex="0">
                          セールスフォース、潰えなかった成長期待
                        </span>
                      </h2>
                    </div>
                    <p className="abstractText css-1e99ddv">
                      　成長率が一桁だと、シリコンバレーのソフトウエア会社は息絶えるか、少なくとも配当金を支払い始める。だがセールスフォースは違う。市場予想が悲観的だったため、8-10月決算の業績と見通しは朗報となった。
                    </p>
                  </div>
                </div>
                <div className="css-1c4gv1e">
                  <button
                    type="button"
                    data-testid="button"
                    className="css-1x9dujs"
                    aria-label="シティグループ"
                    aria-expanded="false"
                    aria-pressed="false"
                  >
                    <span className="css-1h6ames">C</span>
                  </button>
                  <button
                    type="button"
                    data-testid="button"
                    className="css-1x9dujs"
                    aria-label="米マイクロソフト"
                    aria-expanded="false"
                    aria-pressed="false"
                  >
                    <span className="css-1h6ames">MSFT</span>
                  </button>
                  <button
                    type="button"
                    data-testid="button"
                    className="css-1x9dujs"
                    aria-label="セールスフォース"
                    aria-expanded="false"
                    aria-pressed="false"
                  >
                    <span className="css-1h6ames">CRM</span>
                  </button>
                </div>
              </div>
            </div>
            <div className="css-1pubcq1">
              <hr
                data-testid="divider"
                aria-hidden="true"
                className="css-v5tibb"
              />
            </div>
          </div>
          <div className="css-5zdua">
            <div className="css-3y5ajr">
              <div className="leftBox css-5gl0vl" width="100%">
                <div
                  className="topMetadata css-fikby2"
                  data-testid="MainMetadata"
                >
                  <div className="css-1dq90q3">
                    <p className="css-1fj6odc">
                      WSJ Japanese, 16 Apr 2024, 16:17 AWST
                    </p>
                  </div>
                </div>
                <div data-testid="HeadlineContentDiv" className="css-1g0ixsb">
                  <div className="headlinesDiv css-5gl0vl" width="100%">
                    <div className="css-a087gx">
                      <h2 className="headline css-dbb3w6" tabIndex="0">
                        <span role="link" tabIndex="0">
                          セクションテスト240416
                        </span>
                      </h2>
                    </div>
                    <p className="abstractText css-1anudkt">
                      　セクションテスト240416セクションテスト240416セクションテスト240416セクションテスト240416セクションテスト240416
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="css-1pubcq1">
              <hr
                data-testid="divider"
                aria-hidden="true"
                className="css-v5tibb"
              />
            </div>
          </div>
          <div className="css-5zdua">
            <div className="css-3y5ajr">
              <div className="leftBox css-5gl0vl" width="100%">
                <div
                  className="topMetadata css-fikby2"
                  data-testid="MainMetadata"
                >
                  <div className="css-1dq90q3">
                    <p className="css-1fj6odc">
                      WSJ Japanese, 01 Dec 2023, 18:59 AWST
                    </p>
                  </div>
                </div>
                <div data-testid="HeadlineContentDiv" className="css-1g0ixsb">
                  <div className="headlinesDiv css-5gl0vl" width="100%">
                    <div className="css-a087gx">
                      <h2 className="headline css-dbb3w6" tabIndex="0">
                        <span role="link" tabIndex="0">
                          米原潜、対中の圧倒的優位は終わるかDefault
                        </span>
                      </h2>
                    </div>
                    <p className="abstractText css-1anudkt">
                      　何十年もの間、米国は中国の潜水艦をあまり心配する必要がなかった。中国の潜水艦は騒音を立てるため、追跡が容易だった。一方、中国軍は米国の超静音化された潜水艦を探知するのに苦労していた。Default
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="css-1pubcq1">
              <hr
                data-testid="divider"
                aria-hidden="true"
                className="css-v5tibb"
              />
            </div>
          </div>
          <div className="css-5zdua">
            <div className="css-3y5ajr">
              <div className="leftBox css-5gl0vl" width="100%">
                <div
                  className="topMetadata css-fikby2"
                  data-testid="MainMetadata"
                >
                  <div className="css-1dq90q3">
                    <p className="css-1fj6odc">
                      WSJ Japanese, 06 Oct 2023, 09:37 AWST
                    </p>
                  </div>
                </div>
                <div data-testid="HeadlineContentDiv" className="css-1g0ixsb">
                  <div className="headlinesDiv css-5gl0vl" width="100%">
                    <div className="css-a087gx">
                      <h2 className="headline css-dbb3w6" tabIndex="0">
                        <span role="link" tabIndex="0">
                          TEST:ロシアを欺くウクライナ「おとり兵器」
                        </span>
                      </h2>
                    </div>
                    <p className="abstractText css-1anudkt">
                      　ウクライナ鉄鋼最大手の幹部は、ロシア軍がもっと多くの自社製品を標的にしてほしいと望んでいる。
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="css-1pubcq1">
              <hr
                data-testid="divider"
                aria-hidden="true"
                className="css-v5tibb"
              />
            </div>
          </div>
          <div className="css-5zdua">
            <div className="css-3y5ajr">
              <div className="leftBox css-5gl0vl" width="100%">
                <div
                  className="topMetadata css-fikby2"
                  data-testid="MainMetadata"
                >
                  <div className="css-1dq90q3">
                    <p className="css-1fj6odc">
                      WSJ Japanese, 18 Oct 2023, 12:30 AWST
                    </p>
                  </div>
                </div>
                <div data-testid="HeadlineContentDiv" className="css-1g0ixsb">
                  <div className="headlinesDiv css-5gl0vl" width="100%">
                    <div className="css-a087gx">
                      <h2 className="headline css-dbb3w6" tabIndex="0">
                        <span role="link" tabIndex="0">
                          ガザ戦争が見直し迫る米国防戦略
                        </span>
                      </h2>
                    </div>
                    <p className="abstractText css-1anudkt">
                      軍事的プレゼンスを縮小してきた中東で拠点を再構築するバイデン政権
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="css-1pubcq1">
              <hr
                data-testid="divider"
                aria-hidden="true"
                className="css-v5tibb"
              />
            </div>
          </div>
          <div className="css-5zdua">
            <div className="css-3y5ajr">
              <div className="leftBox css-5gl0vl" width="100%">
                <div
                  className="topMetadata css-fikby2"
                  data-testid="MainMetadata"
                >
                  <div className="css-1dq90q3">
                    <p className="css-1fj6odc">
                      WSJ Japanese, 23 Oct 2023, 19:14 AWST
                    </p>
                  </div>
                </div>
                <div data-testid="HeadlineContentDiv" className="css-1g0ixsb">
                  <div className="headlinesDiv css-5gl0vl" width="100%">
                    <div className="css-a087gx">
                      <h2 className="headline css-dbb3w6" tabIndex="0">
                        <span role="link" tabIndex="0">
                          TEST：日銀総裁にバーナンキ氏
                        </span>
                      </h2>
                    </div>
                    <p className="abstractText css-1e99ddv">
                      　香港株式市場の低迷は、香港という都市が直面している課題を象徴している。
                    </p>
                  </div>
                </div>
                <div className="css-1c4gv1e">
                  <button
                    type="button"
                    data-testid="button"
                    className="css-1x9dujs"
                    aria-label="香港取引所"
                    aria-expanded="false"
                    aria-pressed="false"
                  >
                    <span className="css-1h6ames">HK:388</span>
                  </button>
                </div>
              </div>
            </div>
            <div className="css-1pubcq1">
              <hr
                data-testid="divider"
                aria-hidden="true"
                className="css-v5tibb"
              />
            </div>
          </div>
          <div className="css-5zdua">
            <div className="css-3y5ajr">
              <div className="leftBox css-5gl0vl" width="100%">
                <div
                  className="topMetadata css-fikby2"
                  data-testid="MainMetadata"
                >
                  <div className="css-1dq90q3">
                    <p className="css-1fj6odc">
                      WSJ Japanese, 06 Oct 2023, 09:02 AWST
                    </p>
                  </div>
                </div>
                <div data-testid="HeadlineContentDiv" className="css-1g0ixsb">
                  <div className="headlinesDiv css-5gl0vl" width="100%">
                    <div className="css-a087gx">
                      <h2 className="headline css-dbb3w6" tabIndex="0">
                        <span role="link" tabIndex="0">
                          TEST:米財政赤字、金利上昇でいよいよ問題に
                        </span>
                      </h2>
                    </div>
                    <p className="abstractText css-1e99ddv">
                      　低インフレ時代には無視してきた投資家も注意せざるを得ない状況だ。
                    </p>
                  </div>
                </div>
                <div className="css-1c4gv1e">
                  <button
                    type="button"
                    data-testid="button"
                    className="css-1x9dujs"
                    aria-label="ブラックロック"
                    aria-expanded="false"
                    aria-pressed="false"
                  >
                    <span className="css-1h6ames">BLK</span>
                  </button>
                </div>
              </div>
            </div>
            <div className="css-1pubcq1">
              <hr
                data-testid="divider"
                aria-hidden="true"
                className="css-v5tibb"
              />
            </div>
          </div>
          <div className="css-5zdua">
            <div className="css-3y5ajr">
              <div className="leftBox css-5gl0vl" width="100%">
                <div
                  className="topMetadata css-fikby2"
                  data-testid="MainMetadata"
                >
                  <div className="css-1dq90q3">
                    <p className="css-1fj6odc">
                      WSJ Japanese, 06 Oct 2023, 09:25 AWST
                    </p>
                  </div>
                </div>
                <div data-testid="HeadlineContentDiv" className="css-1g0ixsb">
                  <div className="headlinesDiv css-5gl0vl" width="100%">
                    <div className="css-a087gx">
                      <h2 className="headline css-dbb3w6" tabIndex="0">
                        <span role="link" tabIndex="0">
                          TEST:アリゾナの砂漠見下ろす「崖の家」どう建てた？
                        </span>
                      </h2>
                    </div>
                    <p className="abstractText css-1anudkt">
                      「息子は高所恐怖症にはならないと思う」。生後9カ月の息子を抱いたグレンドン・グッドさん（60）は、自宅まで傾斜45度超の急勾配を上昇するゴンドラの中でこう話した。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
